import { useEffect, useState } from "react";

export default function ButtonGroup({ children, handleButtonClick, indexActive, indexSelect }) {
    const [activeIndex, setActiveIndex] = useState(indexSelect);

    useEffect(() => {
        handleChildClick(indexActive);
    }, [indexActive])

    const handleChildClick = (index) => {
        setActiveIndex(index);
        handleButtonClick(index);
    };

    const childrenCount = Array.isArray(children) ? children.length : 1
    const childs = []
    if (childrenCount !== 1) {
        for (let i = 0; i < childrenCount; i++) {
            if (children[i].props.children[1]) {
                const isActive = activeIndex === i;
                const clase = isActive
                    ? "bg-gradient-to-b from-[#0F3460] to-[#0A2540] text-xs lg:text-sm font-Poppins flex-1 rounded-3xl text-white font-medium antialiased p-2 text-[#4D4D4D]"
                    : "text-md text-gray-500 font-medium rounded-3xl focus:text-[#77a3e3] hover:text-[#77a3e3] text-xs lg:text-sm font-Poppins flex-1 border p-2 border-[#334155]";
                childs.push(
                    <button
                        key={i}
                        className={clase}
                        type="button"
                        onClick={() => handleChildClick(i)}
                    >
                        {children[i]}
                    </button>
                );
            }
        }
    } else {
        const isActive = activeIndex === 0;
        const clase = isActive
            ? "bg-gradient-to-b from-[#0F3460] to-[#0A2540] text-xs lg:text-sm font-Poppins flex-1 rounded-3xl text-white font-medium antialiased p-2 text-[#4D4D4D]"
            : "text-md text-gray-500 font-medium rounded-3xl focus:text-[#77a3e3] hover:text-[#77a3e3] text-xs lg:text-sm font-Poppins flex-1 border p-2 border-[#334155]";
        childs.push(
            <button
                key={0}
                className={clase}
                type="button"
                onClick={() => handleChildClick(0)}
            >
                {children}
            </button>
        );
    }

    return (
        <div
            className="flex gap-5 px-5 rounded-lg"
        >
            {childs}
        </div>
    )
}